import {
  Link as RouterLink,
  type LinkProps as RouterLinkProps,
} from "react-router-dom";

export type LinkProps = RouterLinkProps & {
  newPage?: boolean;
};

export default function Link({ newPage, target, rel, ...rest }: LinkProps) {
  return (
    <RouterLink
      {...rest}
      target={newPage ? "_blank" : target}
      rel={newPage ? "noopener noreferrer" : rel}
    />
  );
}
